import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Costanti from '../../constantiX';
import { Toast, TabView,TabPanel, Button, Dialog , FileUpload,InputText, InputTextarea, ConfirmDialog} from "primereact";
import ListaMaterie from "../DettagliProdotto/listaMaterie";
import ListaAllergeni from "../DettagliProdotto/listaAllergeni";
import ListaProduzioni from "../Produzioni/listaProduzioni";
import ListaCertificazioni from "../Certificazioni/listaCertificazioni";
import ListaLotti from "../DettagliProdotto/listaLotti";
import ListaAnnata from "../DettagliProdotto/listaAnnata";
import QRCode from "react-qr-code";
import ListaCaratteristiche from "../DettagliProdotto/listaCaratteristiche";
import { Formik } from 'formik';
import * as Yup from 'yup';
import ReactGA from 'react-ga4';
import { Link } from "react-router-dom";

import Moment from 'moment';

class Prodotto extends React.Component {
   
    constructor() {
        super();
        this.state = { xcarica:'sezione', dati:[], prodotto:{},prodottoid:0, visible3: false ,  editMode: false};
        this.token=sessionStorage.getItem("ICEtoken");
        this.utente=JSON.parse(sessionStorage.getItem("utente"));
   
      }
    
     showMessage(tipo,messageError,dettaglio) {
        var icona='';
        if(tipo=='error'){icona='pi pi-times-circle';}
        if(tipo=='info'){icona='pipi-info-circle';}
        if(tipo=='success'){icona='pi pi-check-circle';}
        if(tipo=='warning'){icona='pi pi-exclamation-triangle';}
        this.toastBC.show({ severity: tipo,  life: 3000, closable: false, content: (
            <div className="flex flex-column" style={{flex: '1'}}>
                <div className="text-center">
                 <i className={icona} style={{fontSize: '3rem'}}></i>
                 <h4>{messageError}</h4>
                 <h5>{dettaglio}</h5>
                </div>
            </div>
        ) });
      }
     setVisible3(val){
        this.setState({ visible3: val });
     } 

     setEditMode(val){
        this.setState({ editMode: val });
     } 

     componentDidMount() {
    
      //alert(this.props.location.pathname);
        ReactGA.send({ hitType: "pageview", page:this.props.location.pathname});
        this.id=this.props.match.params.id;
        this.tipo=this.props.match.params.tipo;
        
        this.setState({tipo:this.props.match.params.tipo, prodottoid:this.props.match.params.id});;

       
       this.carica();

     }

     carica(){
      let config = {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }
     if(this.tipo=='A'){
        this.setState({editMode:true});
     }else{
  
      this.setState({loading:true});
      var quer=this.id;
          axios.get(Costanti.UrlCallApi+"prodotto/"+quer,config)
            .then(res => {
                this.setState({dati:res.data,loading:false,editMode:false})
               //alert(JSON.stringify(this.state.prodotti))
               if(this.tipo=='U')this.setState({editMode:true});

           }).catch(error=> {
         alert(error)
    });
    }
     }
   
     reset() {
        this.setEditMode(false);
        
        this.carica();
    }
    notarizza2() {
     
        this.showMessage('info','Notarizzo', this.state.dati.codiceprodotto+ ' '+ this.state.dati.nome);
      
       let config = {
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        }
        this.setState({isSubmitting:true});
    

        axios.get(Costanti.UrlCallApi+"notarizzazione/prodotto/"+this.state.prodottoid,config)
        .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false, dati:res.data, prodottoid:res.data.id});
           
        }).catch(error=> {
          this.showMessage('error','Errore nel salvataggio',error.message);
          this.setState({isSubmitting:false,editMode:false});
        });
    
    }
    
    
    
    inviaDati(dati) {
        let config = {
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        }
     
      this.setState({isSubmitting:true});
      if(this.state.tipo=='A'){
        dati.aziendaid=this.utente.aziendaid;
        dati.status=' ';
        axios.post(Costanti.UrlCallApi+"prodotto/aggiungi",dati,config)
        .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false,editMode:true,tipo:'U', dati:res.data, prodottoid:res.data.id});
           
        }).catch(error=> {
          this.showMessage('error','Errore nel salvataggio',error.message);
          this.setState({isSubmitting:false,editMode:false});
        });
      }
      if(this.state.tipo=='U'){
        dati.status=' ';
      
        axios.post(Costanti.UrlCallApi+"prodotto/salva/"+this.state.prodottoid,dati,config)
        .then(res => {
        
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false});
            this.carica(this.state.prodottoid);
       }).catch(error=> {
          this.showMessage('error','Errore nel salvataggio',error.message);
          this.setState({isSubmitting:false});
        });
      }
      if(this.state.tipo=='D'){
       dati.status='E';
        axios.post(Costanti.UrlCallApi+"prodotto/salva/"+this.state.prodottoid,dati,config)
        .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false,editMode:false});
       }).catch(error=> {
          this.showMessage('error','Errore nel salvataggio',error.message);
          this.setState({isSubmitting:false,editMode:false});
        });
      }




    }

    elAllegato(){
      let config = {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }
     axios.get(Costanti.UrlCallApi+"file/delete/"+this.utente.aziendaid+'/prodotto/'+this.state.prodottoid,config)
    .then(res => {
       }).catch(error=> {
         alert(error)
    });         
    window.location.reload(false);
  }
    
    setPDF(value){
    
    let dati=
    {
      url:Costanti.BaseHttp
    }
    
      let config = {
           headers: {
             'Authorization': 'Bearer ' + this.token
           }
         }
       axios.post(Costanti.UrlCallApi+"stampe/dettprodotto/"+this.state.prodottoid,dati,config)
       .then((res) => {
  
   const link = document.createElement('a');
   const url=Costanti.UrlCallApi+"file/getFile/"+res.data;
   
   link.href = url;
   link.setAttribute(
     'download',
     res.data
   );
   // Append to html link element page
   document.body.appendChild(link);
   // Start download
   link.click();
   // Clean up and remove the link
   link.parentNode.removeChild(link);
    }).catch(error=> {
           this.showMessage('error','Errore nella stampa',error.message);
       this.setState({isSubmitting:false});
   });

   }

   lingua(){
    var a="";
    if(document.getElementById("aaGG"))
    a=document.getElementById("aaGG").innerText;
    if(a==="") a=(navigator.language=== 'it-IT'?"IT":"UK");
    return a;
  }
 
  validationSchema() {
    return Yup.object().shape({
      codiceprodotto: Yup.string()
        .required('codiceprodotto obbligatorio')
        .typeError('codiceprodotto obbligatorio'),
      nome: Yup.string()
        .required('Nome obbligatorio')
        .typeError('Nome obbligatorio')
    
    
    });
}
      
      render() {
        return( 
        <div className="surface-section px-1 py-9 md:px-6 lg:px-8">
             <Toast ref={(el) => this.toastBC = el} position="bottom-center" />
       
         
        {(this.state.prodottoid>0)?<div className="col-12 lg:col-12">
        <Link to="/listaProdotti">Torna alla lista
              </Link>
            <Button label={(this.state.dati.nome+'    ['+ this.state.dati.codiceprodotto+']')}  className="ml-3 p-button-outlined font-bold p-button p-button-danger" disabled="true"/>
            {(this.utente.ruoloid==3 || Costanti.Ambiente=='TEST') && !this.state.dati.lastnotarize?
              <Button label="Notarizza" onClick={()=> this.setVisible3(true)}  icon="pi pi-building" className="p-button-rounded p-button-warning" />
              :""}

            {(this.utente.ruoloid==3 || Costanti.Ambiente=='TEST')  && this.state.dati.lastnotarize?
              <Button label={"Ultima Notarizzazione "+( Moment(new Date(this.state.dati.lastnotarize)).format("DD/MM/yyyy HH:mm:ss"))}  className="ml-3 p-button-outlined font-bold p-button p-button-danger mx-2" disabled="true"/>
              :""}
            
            <Button label="Esporta in Pdf" onClick={()=>this.setPDF(true)}   icon="pi pi-file-pdf" className="mx-2 p-button-rounded p-button-danger "/> 
 
           </div>:""}
        <TabView >
        <TabPanel header="Dettaglio">
        <Formik  initialValues={{ 
        nome: this.state.dati.nome, 
        nomeen:this.state.dati.nomeen,
        immagine: this.state.dati.immagine, 
        codiceprodotto: this.state.dati.codiceprodotto, 
        descrizione: this.state.dati.descrizione,
        descrizioneen:this.state.dati.descrizioneen }}
          enableReinitialize
          validationSchema={this.validationSchema}
      
          onSubmit={(values) => {
          this.inviaDati(values);
       }}>
       {({
         values,
         errors,
         touched,
         handleChange,
         handleBlur,
         handleSubmit,
        
       }) => (
        <form onSubmit={handleSubmit}>
        <div className="grid mb-7">


               
        <div className="col-12 lg:col-2">
       
        <div className="flex align-items-center"> 
             {this.state.dati.hasImage? 
                  <img src={Costanti.UrlCallApi+'file/get/'+this.utente.aziendaid+'/prodotto/'+this.state.prodottoid} className="w-full" alt="" />
                  :""}
                </div>
             <div className="flex align-items-center">    
                <FileUpload disabled={!this.state.editMode} id="avatar2" mode="basic" name="avatar"
                 url={Costanti.UrlCallApi+'file/carica/'+this.utente.aziendaid+'/prodotto/'+this.state.prodottoid} 
                 onError={()=> this.showMessage('error','Errore','Si è verificato un errore nel caricamento')}
                 onUpload={()=>window.location.reload(false)}
                 onValidationFail={()=> this.showMessage('error','Errore','Dimensione file errato')}
                accept="image/*" maxFileSize={10000000} chooseOptions={{ className: 'p-button-plain p-button-outlined' }} 
                chooseLabel={this.state.dati.hasImage?"Modifica":"Aggiungi"} />
             </div>
            {this.state.dati.hasImage?<Button type="button" label="Elimina" className="w-full ml-1" 
                  onClick={(e)=>{e.stopPropagation();this.elAllegato()}}></Button>:""}   
        </div>
        <div className="col-12 lg:col-10 py-3 lg:pl-6">

        <div className="grid formgrid p-fluid">
            <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
               <div className="field mb-1 col-12 md:col-5">



             
                    <label htmlFor="nome" className="font-medium text-600">
                    <img src="images/flag_placeholder.png" className="flag flag-it"/>Nome
                    
                      </label>
                      <InputText name="nome" readOnly={!this.state.editMode} value={values.nome} onChange={handleChange} onBlur={handleBlur} type="text" />
                      <div style={{color:'red'}}>{errors.nome && touched.nome && errors.nome}</div>
                    <label htmlFor="nomeen" className="font-medium text-600">
                       <img src="images/flag_placeholder.png" className="flag flag-uk"/>Name
                       </label>
                       <InputText name="nomeen" readOnly={!this.state.editMode} value={values.nomeen} onChange={handleChange} onBlur={handleBlur} type="text" />
               
               
                 </div>
                <div className="field mb-1 col-12 md:col-5">
                    <label htmlFor="codiceprodotto" className="font-medium text-600">Codice Prodotto</label>
                    <InputText id="codiceprodotto" name="codiceprodotto" readOnly={!this.state.editMode} value={values.codiceprodotto} onChange={handleChange} onBlur={handleBlur} type="text" />
                    <div style={{color:'red'}}>{errors.codiceprodotto && touched.codiceprodotto && errors.codiceprodotto}</div>    </div>
                {/*<div className="field mb-1 col-12 md:col-5">
                    <label htmlFor="immagine" className="font-medium text-600">Prodotto</label>
                    <InputText id="immagine" name="immagine" readOnly={!this.state.editMode} value={values.immagine} onChange={handleChange} onBlur={handleBlur} type="text" />
       </div>*/}
                <div className="field mb-1 col-12 md:col-2">
                <div    style={{ height: "auto", margin: "0 auto", maxWidth: 96, width: "100%" }}>
                
                {(this.state.prodottoid>0)?
                <a target="_blank" href={Costanti.UrlCallApi+'file/qrcode/'+this.state.prodottoid+'?base='+Costanti.BaseHttpFe}>
                    <QRCode
                     size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={Costanti.BaseHttpFe+'#/scheda/'+this.state.prodottoid}
                        viewBox={`0 0 256 256`}
                        /></a>:""}
                </div></div>
                <div className="field mb-1 col-12 md:col-12">


               
                    <label htmlFor="descrizione" className="font-medium text-600">
                    <img src="images/flag_placeholder.png" className="flag flag-it"/>Descrizione
                    
                      </label>
                      <InputTextarea id="descrizione" name="descrizione" readOnly={!this.state.editMode} rows={4} autoResize value={values.descrizione} onChange={handleChange} onBlur={handleBlur}  />
                    
                    <label htmlFor="descrizioneen" className="font-medium text-600">
                       <img src="images/flag_placeholder.png" className="flag flag-uk"/>Description
                       </label>
                       <InputTextarea id="descrizioneen" name="descrizioneen" readOnly={!this.state.editMode} rows={4} autoResize value={values.descrizioneen} onChange={handleChange} onBlur={handleBlur}  />
                     
            
                  
                </div>
                </div>
          
        </div>

        <div className="flex justify-content-between lg:block border-top-1 lg:border-top-none surface-border py-3 lg:py-0 mt-3 lg:mt-0">
            {this.state.tipo=='A'?<Button label="Aggiungi" className="ml-3 p-button-outlined font-bold pi"/>:""}
             {this.state.tipo=='U'?<Button label="Salva"  className="ml-3 p-button-outlined font-bold pi"/>:""}
            {this.state.editMode?<Button type="button" onClick={()=>this.reset()}label="Annulla" className="ml-3 p-button-outlined font-bold pi"/>:""}
            {this.state.tipo=='D'?<Button label="Elimina"  className="ml-3 p-button-outlined font-bold pi"/>:""}
        </div></div>
        </form>
        )}
         </Formik>


        </TabPanel>
        <TabPanel header="Caratteristiche">
            <ListaCaratteristiche prodottoid={this.state.prodottoid} stato={this.state.tipo}/>
        </TabPanel>
        <TabPanel header="Materie Prime">
            <ListaMaterie prodottoid={this.state.prodottoid} stato={this.state.tipo}/>
        </TabPanel>
        {(sessionStorage.getItem("Allergeni")?
          <TabPanel header="Allergeni">
            <ListaAllergeni prodottoid={this.state.prodottoid} stato={this.state.tipo}/>
        </TabPanel>:"")}
        <TabPanel header="Produzione">
            <ListaProduzioni prodottoid={this.state.prodottoid} stato={this.state.tipo}/>
        </TabPanel>
        {(sessionStorage.getItem("Annate")?
          <TabPanel header="Annate">
            <ListaAnnata prodottoid={this.state.prodottoid} stato={this.state.tipo}/>
        </TabPanel>:"")}
        <TabPanel header="Lotti">
            <ListaLotti prodottoid={this.state.prodottoid} stato={this.state.tipo}/>
        </TabPanel>
        <TabPanel header="Certificazioni">
            <ListaCertificazioni prodottoid={this.state.prodottoid}/>
        </TabPanel>
        </TabView>


<ConfirmDialog visible={this.state.visible3} onHide={() => this.setVisible3(false)} 
    message="Hai valorizzato tutti i dati che andranno su Blockchain?"
    icon="pi pi-exclamation-triangle" 
    acceptLabel="Conferma"
    rejectLabel="Annulla"
    accept={() =>this.notarizza2()} 
    reject={() => this.setVisible3(false)} />

  


        </div>
      )  
    }
    }

    export default Prodotto;